<template>
  <v-card>
    <v-card-text class="d-flex align-start pt-7 grey--text text--darken-3">
      <slot name="default"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SurveyQuestionCard'
}
</script>

<style scoped>

</style>
